import styled from "@emotion/styled";
import { fontMerriweather } from "@product/scmp-sdk";

import { Figure, StyledFigcaption } from "~/components/content/content-cover-image/styles";
import { EntityLink } from "~/components/entity-link";

export const Container = styled.div`
  ${props => props.theme.breakpoints.only("mobile")} {
    display: flex;
    flex-direction: column-reverse;
  }
`;

export const Content = styled.div``;

export const StyledEntityLink = styled(EntityLink)`
  display: block;

  color: #000000;
`;

export const LinkHighlightArea = styled.div``;

export const Section = styled.div`
  margin-block-end: 8px;
`;

export const Headline = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 12px;
  align-items: flex-start;

  margin-block-end: 12px;

  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 25.2px;

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 22px;
    line-height: 30.8px;
  }
`;

export const Summary = styled.div`
  margin-block-end: 12px;

  color: #6f6f6f;
  font-size: 14px;
  line-height: 18.2px;
`;

export const ActionBar = styled.div`
  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 20px;
  }
  time {
    color: #999999;
    font-size: 12px;
  }
`;

export const CoverImage = styled.div`
  ${Figure} picture {
    aspect-ratio: 3/2;

    img {
      aspect-ratio: inherit;
    }
  }

  ${StyledFigcaption} {
    display: none;

    ${props => props.theme.breakpoints.up("tablet")} {
      display: block;

      line-height: 14px;
    }
  }

  ${props => props.theme.breakpoints.only("mobile")} {
    margin-block-end: 12px;
  }
`;
